<script lang="ts">
	import { AdaptiveTextInput, SearchIcon_2 } from "@hitit/new_ui/src";
	export let placeholder = "";
	export let searchCallback: (search: string) => Promise<results> = (
		search: string
	) => Promise.resolve([]);

	type results = { name: string; callback: () => void }[];

	export let search = "";
	export let noFocusoutline = true;
	export let inputBackgroundColor = "";
	let searchResult: results = [];
	let timeout: any;

	const inputHandler = () => {
		if (timeout) clearTimeout(timeout);
		if (search === "") {
			searchResult = [];
			return;
		}
		timeout = setTimeout(async () => {
			searchResult = await searchCallback(search);
		}, 150);
	};

	const clickOutside = (node: HTMLElement) => {
		function handleClick(event: Event) {
			const target = event.target as HTMLElement;
			if (node && !node.contains(target)) {
				if (target.classList.contains("search-result")) {
					target.click();
				}
				searchResult = [];
			}
		}

		document.addEventListener("click", handleClick, true);

		return {
			destroy() {
				document.removeEventListener("click", handleClick, true);
			},
		};
	};

</script>

<div class="container">
	<AdaptiveTextInput
		noFocusoutline={noFocusoutline}
		backgroundColor={inputBackgroundColor}
		action={clickOutside}
		bind:value={search}
		placeholder={placeholder}
		on:input={inputHandler}>
		<div class="search-icon" slot="left-icon">
			<SearchIcon_2 />
		</div>
	</AdaptiveTextInput>
	{#if searchResult.length > 0}
		<ul class="search-results">
			{#each searchResult as result}
				<li class="search-result" on:click={result.callback}>{result.name}</li>
			{/each}
		</ul>
	{/if}
</div>

<style lang="scss">
	@import "../variables.scss";

	.container {
		width: 100%;
		height: 31px;
		color: #46474b;
		position: relative;

		.search-icon {
			width: 15.8px;
			height: 15.8px;
			margin-right: 10px;
		}

		.search-results {
			position: absolute;
			top: 41px;
			width: 100%;
			max-height: 97px;
			display: flex;
			flex-direction: column;
			padding: 5px 0px;
			box-sizing: border-box;
			background-color: white;
			border-radius: 5px;
			list-style: none;
			margin: 0;
			overflow-y: auto;
			z-index: 1;
			box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
			&::-webkit-scrollbar {
				width: 2px;
			}
			&::-webkit-scrollbar-track {
				background-color: transparent;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #bcbfc3;
			}

			li {
				width: 100%;
				box-sizing: border-box;
				max-width: 100%;
				padding: 5px 10px;

				&:hover {
					cursor: pointer;
					font-weight: 200;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			height: 40px;
			font-size: 1.25rem;
			.search-icon {
				width: 23.5px;
				height: 25.5px;
			}

			.search-results {
				top: 51px;
				max-height: 170px;
				padding: 10px 0px;

				li {
					padding: 10px 20px;
				}
			}
		}
	}

</style>
